import React from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import { LegacyOrNotFound } from "./components/layout/shell/legacy/LegacyOrNotFound";
import { PipelineMaintenancePage } from "./pages/pipelineMaintenance/PipelineMaintenance";
import PipelineMaintenanceCreatePipelinePage from "./pages/pipelineMaintenance/PipelineMaintenanceCreatePipelinePage";
import PipelineMaintenanceEditPipelinePage from "./pages/pipelineMaintenance/PipelineMaintenanceEditPipelinePage";
import { ProjectServicesMaintenancePage } from "./pages/projectServicesMaintenance/ProjectServicesMaintenance";
import "./index.css";
import { ProjectUserDefinedMaintenancePage } from "./pages/UserDefined/projectUserDefinedMaintenance";
import { RolesProvider } from "./providers";
import { Toaster } from "./components/shadcn/sonner";
import { ProductUserDefinedMaintenancePage } from "./pages/UserDefined/productUserDefinedMaintenance";
import { CompanyUserDefinedMaintenancePage } from "./pages/UserDefined/companyUserDefinedMaintenance";
import { ContactUserDefinedMaintenancePage } from "./pages/UserDefined/contactUserDefinedMaintenance";
import { CrmLibraryItemCreateEditPage } from "./pages/crmLibraryItem/CrmLibraryItemCreateEditPage";
import { FunnelChart } from "./pages/crmLibraryItem/components/FunnelChart";
import { WebhookMaintenance, WebhookMaintenanceCreate, WebhookMaintenanceEdit, WebhookMaintenanceView } from "./pages/WebhookMaintenance";
import { ContactDetailPage } from "./pages/ContactDetail";
import { AddContactPage } from "./pages/AddContact";
import { AiChatPanel } from "./components/specific/ai/AiChatPanel";
import { EngagementWidget } from "./components/specific/engagement";
import { EngagementPage } from "./pages/engagement/EngagementPage";
import { AiPage, AskVectaPage } from "@/features/ai";
import { RfmPage } from "./pages/rfm/RfmPage";
import { AppShell } from "./components/layout/shell";
import { MegaFooter } from "./components/layout/shell/MegaFooter";
import { LoginPage } from "./pages/login/LoginPage";
import { AccountSettingsPage } from "@/features/accountSettings";
import { CustomerMailPage, MailInboxPage } from "@/features/mail";
import { EmailOptionsPage } from "@/features/emailOptions";
import { claimFrameBreakOut } from "@/utils/legacyShell";

// LEGACY: assign the current instance of jquery to the window object to preserve existing functionality
// @ts-ignore - jquery is not defined in the current context and exists in the hosting page
if (typeof $ !== "undefined") window.$ = $;
// @ts-ignore - underscore is not defined in the current context and exists in the hosting page
if (typeof _ !== "undefined") window._ = _;

// const router = createBrowserRouter([
//   {
//     path: "/pipelineMaintenance",
//     element: <><h1 className="text-red-500">Hello World!</h1></>,
//     errorElement: <div>404 Not Found</div>,
//   },
//   // {
//   //   path: "/pipelineMaintenance/Details/:id",
//   //   element: <PipelineMaintenanceDetailsPage />,
//   // },
//   // {
//   //   path: "/pipelineMaintenance/CreatePipeline",
//   //   element: <PipelineMaintenanceCreatePipelinePage />,
//   // },
// ]);


document.addEventListener("DOMContentLoaded", () => {
  if (document.getElementById("react-root") && window.self !== window.top) {
    if (window.top && claimFrameBreakOut(window.sessionStorage, window.location.href)) window.top.location.href = window.location.href;
  } else if (document.getElementById("react-root")) {
    ReactDOM.createRoot(document.getElementById("react-root") as HTMLElement).render(
      <React.StrictMode>
        <RolesProvider>
          <BrowserRouter>
            <AppShell>
              <Routes>
                <Route index path="projectServicesMaintenance" element={<ProjectServicesMaintenancePage />} />
                <Route index path="pipelineMaintenance" element={<PipelineMaintenancePage />} />
                <Route index path="Engagement" element={<EngagementPage />} />
                <Route path="Emails" element={<MailInboxPage />} />
                <Route path="Options/EmailOptions" element={<EmailOptionsPage />} />
                <Route index path="RFM" element={<RfmPage />} />
                <Route path="pipelineMaintenance/CreatePipeline" element={<PipelineMaintenanceCreatePipelinePage />} />
                <Route path="pipelineMaintenance/EditPipeline/:id" element={<PipelineMaintenanceEditPipelinePage />} />
                <Route index path="projectUserDefinedMaintenance" element={<ProjectUserDefinedMaintenancePage />} />
                <Route index path="companyUserDefinedMaintenance" element={<CompanyUserDefinedMaintenancePage />} />
                <Route index path="contactUserDefinedMaintenance" element={<ContactUserDefinedMaintenancePage />} />
                <Route index path="productUserDefinedMaintenance" element={<ProductUserDefinedMaintenancePage />} />
                <Route index path="libraryItemMaintenance/CreateCrmItem" element={<CrmLibraryItemCreateEditPage />} />
                <Route index path="libraryItemMaintenance/EditCrmItem/:id" element={<CrmLibraryItemCreateEditPage />} />
                <Route path="maintenance/ai" element={<AiPage />} />
                <Route path="AskVecta" element={<AskVectaPage />} />
                <Route path="maintenance/webhook/edit/:id" element={<WebhookMaintenanceEdit />} />
                <Route path="maintenance/webhook/create" element={<WebhookMaintenanceCreate />} />
                <Route path="maintenance/webhook/:id" element={<WebhookMaintenanceView />} />
                <Route path="maintenance/webhook" element={<WebhookMaintenance />} />
                <Route path="contact/add/:companyId" element={<AddContactPage />} />
                <Route path="contact/:id" element={<ContactDetailPage />} />
                <Route path="AccountSettings" element={<AccountSettingsPage />} />
                <Route path="*" element={<LegacyOrNotFound />} />
              </Routes>
            </AppShell>
            <Toaster />
          </BrowserRouter>
        </RolesProvider>
      </React.StrictMode>
    );
  }

  // Render a single funnel chart
  const renderFunnelChart = (div: Element) => {
    try {
      const hiddenField = div.querySelector('#reactChartJson') as HTMLInputElement;
      const reactFunnel = div.querySelector('.react-funnel');

      if (hiddenField && hiddenField.value) {
        const chartData = JSON.parse(hiddenField.value);
        
        // Create a React root and render the FunnelChart
        const root = ReactDOM.createRoot(reactFunnel as HTMLElement);
        root.render(
          <React.StrictMode>
            <FunnelChart data={chartData} />
          </React.StrictMode>
        );
      }
    } catch (error) {
      console.error('Error rendering funnel chart:', error, div);
    }
  };

  // Function to check for and render funnel charts
  const checkForFunnelCharts = () => {
    const funnelDivs = document.querySelectorAll('.react-funnel-container');
    funnelDivs.forEach(renderFunnelChart);
  };

  // Initial check
  checkForFunnelCharts();

  // Listen for custom events that can be triggered from non-react code
  window.addEventListener('funnelChartsReady', () => {
    checkForFunnelCharts();
  });

  // Mount engagement widget embedded in legacy WebForms pages
  document.querySelectorAll<HTMLElement>('.react-engagement-widget').forEach(el => {
    const companyId = el.dataset.companyId;
    if (!companyId) return;
    ReactDOM.createRoot(el).render(
      <React.StrictMode>
        <EngagementWidget filters={{ companyIds: [companyId] }} />
      </React.StrictMode>
    );
  });

  // Mount the customer Emails tab embedded in the legacy customer dashboard
  document.querySelectorAll<HTMLElement>('.react-customer-mail').forEach(el => {
    const companyId = el.dataset.companyId;
    if (!companyId) return;
    ReactDOM.createRoot(el).render(
      <React.StrictMode>
        <CustomerMailPage companyId={companyId} />
      </React.StrictMode>
    );
  });

  // Check if the API chat root element exists and render the chat panel if it does
  if (document.getElementById("ai-chat-root")) {
    ReactDOM.createRoot(document.getElementById("ai-chat-root") as HTMLElement).render(
      <React.StrictMode>
        <AiChatPanel showToggle={false} />
      </React.StrictMode>
    );
  }

  // Render the mega footer on legacy WebForms and MVC pages
  if (document.getElementById("react-mega-footer-root")) {
    // application_routes is injected by the server into every legacy page.
    // userPreferences is not in that global, so we patch in its well-known path.
    // @ts-ignore - application_routes is defined in the hosting page
    const legacyRoutes = typeof application_routes !== "undefined" ? application_routes : {};
    ReactDOM.createRoot(document.getElementById("react-mega-footer-root") as HTMLElement).render(
      <React.StrictMode>
        <MegaFooter routes={{
          ...legacyRoutes,
          userPreferences: "UserPref.aspx",
          accountSettings: "/AccountSettings",
        }} />
      </React.StrictMode>
    );
  }

  // Render the login page (anonymous — no AppShell or BrowserRouter)
  if (document.getElementById("react-login-root")) {
    ReactDOM.createRoot(document.getElementById("react-login-root") as HTMLElement).render(
      <React.StrictMode>
        <LoginPage />
      </React.StrictMode>
    );
  }

  //used for pages/components that are still using legacy routing
  // if (document.getElementById("project-services")) {
  //   ReactDOM.createRoot(document.getElementById("project-services") as HTMLElement).render(
  //     <React.StrictMode>
  //       <ProjectServicesMaintenancePage />
  //     </React.StrictMode>
  //   );
  // }
});
